import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { CcfMaintenanceModeProvider } from "../../shared/maintenance/maintenance-mode-provider";
import { CCF_ROUTE_SEGMENTS } from "../../shared/routing/paths/ccf";
import { commonLabels } from "../../shared/ui/labels/common-labels";
import { DataCollection } from "./data-collection";
import { CcfAuthorisationGuard } from "./guards/ccf-authorisation.guard";
import { CcfCalculationOverview, CcfCalculationResult, CcfManagement } from "./lazy-pages";

// Breadcrumb labels sit on the routes (`handle.crumb`, see `shared/layout/breadcrumbs.tsx`): the
// trail is the chain of matched routes carrying one, so the CCF pages nest under the `ccf` route
// rather than listing "Corporate Carbon Footprint" themselves.
export const CCFRoutes = {
  element: (
    <CcfAuthorisationGuard>
      <CcfMaintenanceModeProvider>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </CcfMaintenanceModeProvider>
    </CcfAuthorisationGuard>
  ),
  path: CCF_ROUTE_SEGMENTS.root,
  handle: { crumb: commonLabels.navigation.ccf },
  children: [
    { index: true, element: <CcfManagement /> },
    { path: CCF_ROUTE_SEGMENTS.calculationId, element: <CcfCalculationOverview /> },
    { path: `${CCF_ROUTE_SEGMENTS.calculationId}/${CCF_ROUTE_SEGMENTS.result}`, element: <CcfCalculationResult /> },
    DataCollection,
  ],
};
